window.addEventListener('message', function (event) {
  let data;

  try {
    data = JSON.parse(event.data);
  } catch (_) {
    return;
  }

  if (data.action === 'closeCatfish') {
    const closeButton = document.querySelector('#catfish-close');
    if (closeButton) {
      closeButton.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
    }
  }
});
